export const URLS = {
    BASE_URL_PROD: 'https://api.tulu.io',
    BASE_URL_DEV: 'https://api.dev.tulu.io',
    BASE_URL_LOCAL: 'http://localhost:8080',
}